import { render, staticRenderFns } from "./disciplinaryTypesList.vue?vue&type=template&id=f53544e6"
import script from "./disciplinaryTypesList.vue?vue&type=script&lang=js"
export * from "./disciplinaryTypesList.vue?vue&type=script&lang=js"
import style0 from "./disciplinaryTypesList.vue?vue&type=style&index=0&id=f53544e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports